





import Vue from 'vue'
import * as types from '@/store/modules/play/types'

export default Vue.extend({
  name: 'TrackStart',

  props: {
    trackIndex: {
      type: Number,
      required: true,
    },
    trackHeight: {
      type: Number,
      required: true,
    },
  },

  computed: {
    /**
     * 選択中のトラック
     */
    selectedTrackIndex (): types.TrackIndex {
      return this.$store.state[types.moduleName].selectedTrackIndex
    },

    /**
     * 選択中か
     */
    isSelected (): boolean {
      return this.selectedTrackIndex === this.trackIndex
    },

    /**
     * 再生中 or 収録中
     */
    isPlaying (): boolean {
      return this.$store.state[types.moduleName].isPlaying
    },

    /**
     * 再生モード
     */
    playMode (): types.PlayMode {
      return this.$store.state[types.moduleName].playMode
    },

    /**
     * 再生モードで再生中
     */
    isPlayingByPlayMode (): boolean {
      return this.isPlaying && this.playMode === 'play'
    },
  },

  methods: {
    /**
     * このトラックを選択する
     */
    active () {
      this.$store.commit(`${types.moduleName}/${types.Mutation.CHANGE_ACTIVE_TRACK}`, this.trackIndex)
    },
  },
})
